/**
 * Mason Massage logo — recreated as inline SVG so it lives natively on the page background.
 * - `variant="default"`: deep-teal symbol with black cursive "Mason Massage" wordmark (for cream/white surfaces)
 * - `variant="light"`: cream/white symbol + wordmark (for dark surfaces like the footer)
 *
 * The symbol mirrors the brand logo: a water droplet sitting in a cupped lotus/vessel
 * with two graceful waves beneath it.
 */
export default function Logo({ variant = "default", showText = true, size = "md", className = "" }) {
  const isLight = variant === "light";
  const stroke = isLight ? "#FAF7EE" : "#0E5A60";
  const accent = isLight ? "#C9A878" : "#1FB4BC";
  const textColor = isLight ? "text-spa-cream" : "text-spa-dark";

  const dims = {
    sm: { svg: "h-7 w-7", text: "text-2xl" },
    md: { svg: "h-10 w-10", text: "text-3xl" },
    lg: { svg: "h-16 w-16", text: "text-5xl" },
  }[size];

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg viewBox="0 0 64 80" className={dims.svg} fill="none" aria-hidden="true">
        {/* Water droplet */}
        <path
          d="M32 6 C 28 16, 24 22, 24 28 C 24 33, 27 36, 32 36 C 37 36, 40 33, 40 28 C 40 22, 36 16, 32 6 Z"
          fill={accent}
        />
        {/* Cupped lotus / vessel */}
        <path
          d="M14 40 C 18 52, 24 56, 32 56 C 40 56, 46 52, 50 40"
          stroke={stroke}
          strokeWidth="2.2"
          strokeLinecap="round"
          fill="none"
        />
        {/* Inner small curve */}
        <path
          d="M22 42 C 24 50, 28 52, 32 52 C 36 52, 40 50, 42 42"
          stroke={stroke}
          strokeWidth="1.4"
          strokeLinecap="round"
          fill="none"
        />
        {/* Wave 1 */}
        <path
          d="M8 64 Q 16 60, 24 64 T 40 64 T 56 64"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
        {/* Wave 2 */}
        <path
          d="M12 72 Q 20 68, 28 72 T 44 72 T 60 72"
          stroke={accent}
          strokeWidth="1.8"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
      {showText && (
        <span
          className={`font-script ${dims.text} leading-none ${textColor} tracking-tight`}
          style={{ letterSpacing: "-0.01em" }}
        >
          Mason Massage
        </span>
      )}
    </div>
  );
}
